export const statusOption = [
  { key: 1, badgeColor: "warning" },
  { key: 2, badgeColor: "success" },
  { key: 3, badgeColor: "danger" },
];

export const busRecordStatusMode = {
  ACTIVE: "O",
  INACTIVE: "C",
};

export const busModeList = {
  VIEW_BUS_DETAIL: "VIEW_BUS_DETAIL",
  EDIT_BUS_DETAIL: "EDIT_BUS_DETAIL",
};

export const getInitOrderScanParams = () => {
  return {
    sizePerPage: 10,
    page: 1,
    sort: "-maker_date",
    columnFilter: {},
    keywords: "",
    columnsVisible: {},
    fields: "",
    expand: "",
    tracking_key: undefined,
  };
};
